/* eslint-disable import/no-mutable-exports */
import defaultFaq from './AU.json';
import NZFaq from './NZ.json';
import USFaq from './US.json';
import CAFaq from './CA.json';
import SGFaq from './SG.json';
import { ContactUsData } from './types';

let contactUsConfig = defaultFaq as ContactUsData;

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-nz' ||
  process.env.STORE === 'reebelo-nz'
)
  contactUsConfig = NZFaq as ContactUsData;

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-us' ||
  process.env.STORE === 'reebelo-us'
)
  contactUsConfig = USFaq as ContactUsData;

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-ca' ||
  process.env.STORE === 'reebelo-ca'
)
  contactUsConfig = CAFaq as ContactUsData;

if (
  process.env.NEXT_PUBLIC_STORE === 'quista' ||
  process.env.STORE === 'quista'
)
  contactUsConfig = SGFaq as ContactUsData;

export default contactUsConfig;
